import axios from "@/api/axios.js";

export default async function(config) {
  try {
    const data = (await axios.request(config)).data;
    const { success } = data.res;
    return success ? { err: null, info: data.info } : { err: data.info.error };
  } catch (error) {
    return { err: error };
  }
}
